<template>
  <el-dialog
    append-to-body
    :title="isUnload ? '修改装卸点' : '修改取样点或装卸点'"
    :visible.sync="dialogVisible"
    width="680px"
    @close="onClose"
  >
    <el-form ref="form" label-position="left" label-width="80px" :model="form">
      <el-form-item
        label="取样点"
        prop="sampling_point_id"
        v-if="!isUnload"
        :rules="[
          { required: true, message: '请选择取样点', trigger: 'change' }
        ]"
      >
        <el-select
          class="w-96"
          v-model="form.sampling_point_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in samplingPointList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="是否加抽"
        prop="is_system_pumping"
        v-if="!isUnload"
        :rules="[
          { required: true, message: '请选择是否加抽', trigger: 'change' }
        ]"
      >
        <el-radio-group :disabled="isUnload" v-model="form.is_system_pumping">
          <el-radio :label="0">不加抽</el-radio>
          <el-radio :label="1">加抽</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="装卸点"
        prop="warehouse_id"
        :rules="[
          { required: true, message: '请选择装卸点', trigger: 'change' }
        ]"
      >
        <el-select
          class="w-96"
          v-model="form.warehouse_id"
          placeholder="请选择"
          @change="onWarehouseChange"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="showStoragePointSelector"
        label="存储地点"
        prop="storage_point_id"
        :rules="[
          { required: true, message: '请选择存储地点', trigger: 'change' }
        ]"
      >
        <el-select
          class="w-96"
          filterable
          v-model="form.storage_point_id"
          placeholder="请选择"
          @change="onStoragePointChange"
        >
          <el-option
            v-for="item in storagePointList"
            :key="item.storage_point_id"
            :label="`${item.storage_point_id}（${item.storage_point_name}）`"
            :value="item.storage_point_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isUnload: true,
      dialogVisible: false,
      samplingPointList: [],
      warehouseList: [],
      storagePointList: [],
      form: {
        booking_id: "",
        order_type: "",
        car_business_id: "",
        sampling_point_id: "",
        warehouse_id: "",
        storage_point_id: "",
        storage_point_name: "",
        is_system_pumping: 0
      }
    };
  },
  computed: {
    showStoragePointSelector() {
      // 化辅的存储地点等于预约卸货点，修改时只保留一个可编辑来源。
      return false;
    }
  },
  methods: {
    onClose() {
      this.form = {
        booking_id: "",
        order_type: "",
        car_business_id: "",
        sampling_point_id: "",
        warehouse_id: "",
        storage_point_id: "",
        storage_point_name: "",
        is_system_pumping: 0
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    onOpen(booking_info_id, isUnload = false) {
      this.isUnload = isUnload;
      this.dialogVisible = true;
      this.getDetail(booking_info_id);
    },
    onWarehouseChange(value) {
      if (this.form.order_type !== "NB") {
        return;
      }
      // 关键步骤：化辅装卸点名称按 SAP “编码-名称”维护，同时作为存储地点事实保存。
      const warehouse = this.warehouseList.find(item => item.id === value);
      this.form.storage_point_id = value || "";
      this.form.storage_point_name = warehouse ? warehouse.name : "";
    },
    onConfirm() {
      this.$refs.form.validate(async v => {
        if (v) {
          try {
            await this.$common.http({
              url: "/api/queue/admin/update_booking_warehouse",
              data: this.form
            });
            this.dialogVisible = false;
            this.$emit("ok");
          } catch (error) {
            // 保存失败时直接提示，不再误触发父页面刷新掩盖真实错误。
            this.$message.error(error.message || "修改装卸点失败");
          }
        }
      });
    },
    async getDetail(booking_info_id) {
      const res = await this.$common.http({
        url: "/api/queue/admin/query_booking_detail",
        data: {
          booking_info_id
        }
      });
      const {
        id: booking_id,
        order_type,
        queue
        // queue: { car_business_id, sampling_point_id, warehouse_id, is_system_pumping }
      } = res.data.data;
      this.form = {
        booking_id,
        order_type: order_type || "",
        car_business_id: queue ? queue.car_business_id || "" : "",
        sampling_point_id: queue ? queue.sampling_point_id : "",
        warehouse_id: queue ? queue.warehouse_id : "",
        storage_point_id: queue ? queue.storage_point_id : "",
        storage_point_name: queue ? queue.storage_point_name : "",
        is_system_pumping: queue ? queue.is_system_pumping : 0,
      };
      // 兼容未触发下拉变更的直接保存场景，化辅始终让存储地点跟随当前卸货点。
      this.onWarehouseChange(this.form.warehouse_id);
      // 关键步骤：修改点位只能使用当前车辆业务类型已关联的点位，不能加载全量基础资料。
      this.getSamplingPoint(this.form.car_business_id);
      this.getWarehouse(this.form.car_business_id);
    },
    // 按车辆业务类型查询可修改的取样点。
    getSamplingPoint(carBusinessId) {
      if (!carBusinessId) {
        this.samplingPointList = [];
        return;
      }
      this.$common
        .http({
          url: "/api/queue/dispatcher/query_sampling_point",
          data: {
            is_admin: 1,
            car_business_id: carBusinessId
          }
        })
        .then(res => {
          this.samplingPointList = res.data.data;
        });
    },
    // 按车辆业务类型查询可修改的装卸点。
    getWarehouse(carBusinessId) {
      if (!carBusinessId) {
        this.warehouseList = [];
        return;
      }
      this.$common
        .http({
          url: "/api/queue/dispatcher/query_warehouse_by_business_id",
          data: {
            car_business_id: carBusinessId
          }
        })
        .then(res => {
          // 兼容关联接口的 warehouse_name 字段，保持模板统一使用 name。
          this.warehouseList = (res.data.data || []).map(item => ({
            ...item,
            // 关键步骤：关联接口的 id 是 warehouse_business 主键，下拉值必须使用预约队列保存的 warehouse_id。
            id: item.warehouse_id || item.id,
            name: item.warehouse_name || item.name || ""
          }));
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px !important;
}
</style>
